import { apiClient } from './api';

export interface DashboardStats {
  activeIncidents: {
    total: number;
    change: string;
    changeType: 'increase' | 'decrease' | 'neutral';
  };
  upcomingMissions: {
    total: number;
    change: string;
    changeType: 'increase' | 'decrease' | 'neutral';
  };
  activeThreats: {
    total: number;
    change: string;
    changeType: 'increase' | 'decrease' | 'neutral';
  };
  activeInvestigations: {
    total: number;
    change: string;
    changeType: 'increase' | 'decrease' | 'neutral';
  };
  system: {
    totalRoles: number;
    recentLogins: number;
    uptime: string;
    lastUpdated: string;
  };
}

export interface DashboardActivity {
  id: string;
  type: 'user' | 'security' | 'activity' | 'incident' | 'threat';
  title: string;
  description: string;
  timestamp: string;
  severity?: 'MINIMAL' | 'MODERATE' | 'HIGH' | 'minimal' | 'moderate' | 'high';
  user?: string;
}

export interface SystemHealth {
  overall: string;
  services: Array<{
    name: string;
    status: string;
    uptime: string;
    responseTime: string;
  }>;
  lastChecked: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  meta: {
    timestamp: string;
    total?: number;
  };
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    const response = await apiClient.get<DashboardStats>('/api/v1/dashboard/stats');
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error?.message ?? 'Failed to fetch dashboard stats');
  }

  async getRecentActivity(): Promise<DashboardActivity[]> {
    const response = await apiClient.get<DashboardActivity[]>('/api/v1/dashboard/activity');
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error?.message ?? 'Failed to fetch dashboard activity');
  }

  async getSystemHealth(): Promise<SystemHealth> {
    const response = await apiClient.get<SystemHealth>('/api/v1/dashboard/health');
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error?.message ?? 'Failed to fetch system health');
  }
}

export const dashboardService = new DashboardService();